import React from 'react';
import { SlideWrapper, GlassCard, SectionLabel } from './SharedComponents';

export const BlockchainMarketsSlide = ({ slide }) => (
  <SlideWrapper slide={slide} background={
    <div className="fixed inset-0 z-0">
      <div className="absolute inset-0 bg-[#020206]" />
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[1400px] h-[1000px] bg-[#0068ff] opacity-[0.09] blur-[250px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#8b5cf6] opacity-[0.04] blur-[150px] rounded-full" />
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#06b6d4] opacity-[0.03] blur-[120px] rounded-full" />
      <div className="absolute inset-0 opacity-[0.015]" style={{
        backgroundImage: 'linear-gradient(rgba(0,104,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(0,104,255,0.15) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }} />
      <div className="absolute top-10 left-10 w-16 h-16"><div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-[#0068ff]/30 to-transparent" /><div className="absolute top-0 left-0 h-full w-[1px] bg-gradient-to-b from-[#0068ff]/30 to-transparent" /></div>
      <div className="absolute bottom-10 right-10 w-16 h-16"><div className="absolute bottom-0 right-0 w-full h-[1px] bg-gradient-to-l from-[#0068ff]/30 to-transparent" /><div className="absolute bottom-0 right-0 h-full w-[1px] bg-gradient-to-t from-[#0068ff]/30 to-transparent" /></div>
    </div>
  }>
    <div className="relative z-10 flex flex-col items-center justify-center h-full px-8 py-4">
      <div className="flex items-center gap-3 mb-4 animate-fade-in">
        <img src="/logos/WEF.svg" alt="World Economic Forum" className="h-16 opacity-60" />
      </div>

      <div className="animate-scale-in mb-1">
        <span className="text-[80px] md:text-[100px] lg:text-[120px] font-black leading-none bg-gradient-to-b from-[#0068ff] via-[#3d8bff] to-[#0068ff] bg-clip-text text-transparent">
          $867T
        </span>
      </div>
      <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-white/80 text-center max-w-3xl mb-1 animate-slide-up" style={{ animationDelay: '0.1s' }}>
        in Markets Are Open to Blockchain
      </h2>
      <p className="text-white/30 text-sm mb-8 animate-fade-in" style={{ animationDelay: '0.15s' }}>{slide.attribution}</p>

      <div className="flex items-stretch gap-5 w-full max-w-5xl mb-6">
        <GlassCard delay={0.2} className="flex-1 p-6" style={{ borderColor: 'rgba(0,104,255,0.2)' }}>
          <h3 className="text-[#0068ff] font-bold text-sm uppercase tracking-wider mb-4">Traditional Assets Moving to Blockchain</h3>
          <div className="grid grid-cols-2 gap-2">
            {slide.assets.map((asset, idx) => (
              <div key={idx} className="flex items-center gap-2.5 py-2 px-3 rounded-lg" style={{ background: 'rgba(0,104,255,0.05)', border: '1px solid rgba(0,104,255,0.1)' }}>
                <div className="w-1.5 h-1.5 rounded-full bg-[#0068ff]" style={{ boxShadow: '0 0 6px #0068ff60' }} />
                <span className="text-white/70 text-sm">{asset}</span>
              </div>
            ))}
          </div>
        </GlassCard>

        <GlassCard delay={0.3} className="flex-1 p-6" style={{ borderColor: 'rgba(34,197,94,0.2)', background: 'linear-gradient(135deg, rgba(34,197,94,0.06), rgba(34,197,94,0.02))' }}>
          <h3 className="text-[#22c55e] font-bold text-sm uppercase tracking-wider mb-4">Blockchain Enables</h3>
          <div className="space-y-2.5">
            {slide.capabilities.map((cap, idx) => (
              <div key={idx} className="flex items-center gap-3 py-2 px-3 rounded-lg" style={{ background: 'rgba(34,197,94,0.05)', border: '1px solid rgba(34,197,94,0.1)' }}>
                <svg viewBox="0 0 24 24" className="w-4 h-4 text-[#22c55e] shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 13l4 4L19 7" /></svg>
                <span className="text-white/70 text-sm">{cap}</span>
              </div>
            ))}
          </div>
        </GlassCard>
      </div>

      <div className="flex items-center gap-3 mb-5 animate-slide-up" style={{ animationDelay: '0.4s' }}>
        {slide.flow.map((step, idx) => {
          const isLast = idx === slide.flow.length - 1;
          const colors = ['rgba(255,255,255,0.08)', 'rgba(0,104,255,0.1)', 'rgba(0,104,255,0.15)'];
          const borders = ['rgba(255,255,255,0.1)', 'rgba(0,104,255,0.25)', 'rgba(0,104,255,0.4)'];
          return (
            <React.Fragment key={idx}>
              <div className="px-5 py-2.5 rounded-xl text-center" style={{
                background: colors[idx], border: `1px solid ${borders[idx]}`,
                boxShadow: isLast ? '0 0 30px rgba(0,104,255,0.15)' : 'none'
              }}>
                <span className={`text-sm font-semibold ${isLast ? 'text-[#0068ff]' : 'text-white/60'}`}>{step}</span>
              </div>
              {idx < slide.flow.length - 1 && (
                <svg viewBox="0 0 30 12" className="w-7 h-3"><defs><marker id="bkArr" markerWidth="6" markerHeight="4" refX="5" refY="2" orient="auto"><polygon points="0 0,6 2,0 4" fill="#0068ff" opacity="0.6"/></marker></defs><path d="M 2 6 L 24 6" fill="none" stroke="#0068ff" strokeWidth="1.5" strokeOpacity="0.4" markerEnd="url(#bkArr)" /></svg>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <GlassCard delay={0.5} className="px-8 py-3 max-w-3xl text-center" style={{ borderColor: 'rgba(0,104,255,0.15)' }}>
        <p className="text-white/45 text-sm leading-relaxed">{slide.biggerPicture}</p>
      </GlassCard>
    </div>
  </SlideWrapper>
);
